import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import axios from 'axios';
import Breadcrumb from '../components/Breadcrumb';
import Odontograma from './Odontograma';
import html2canvas from 'html2canvas';
import '../styles/Presupuesto.css';

export default function Presupuesto() {
  const history = useHistory();
  const { state } = useLocation();
  const actuaciones = state?.actuaciones || [];
  const [presupuesto, setPresupuesto] = useState([]);
  const expediente = state?.expediente;
  const [odontogramaListo, setOdontogramaListo] = useState(false);
  const odontogramaRef = useRef(null);
  const [observaciones, setObservaciones] = useState('');

  useEffect(() => {
    const idsActuaciones = actuaciones.map(act => act.id); // Asegúrate de que cada actuación tiene un campo `id`
    if (idsActuaciones.length > 0) {
      axios.post('/api/presupuesto', idsActuaciones, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        })
        .then(res => {
          setPresupuesto(res.data);
        })
        .catch(err => {
          console.error("Error al generar presupuesto:", err);
        });
    }
  }, [actuaciones]);

  const calcularTotalFila = (cantidad, importe) => cantidad * importe;

  const totalGlobal = presupuesto.reduce((acc, act) => {
    const cantidad = Number(act.cantidad || 1);
    const importe = Number(act.importe || 0);
    return acc + calcularTotalFila(cantidad, importe);
  }, 0);

  const generarPDF = async () => {
    try {
      const odontogramaDiv = document.getElementById("odontograma-captura");

      odontogramaDiv.style.visibility = "visible";
      odontogramaDiv.style.opacity = "1";
      odontogramaDiv.style.position = "fixed";
      odontogramaDiv.style.top = "0";
      odontogramaDiv.style.left = "0";
      odontogramaDiv.style.zIndex = "-1";
      odontogramaDiv.style.pointerEvents = "none";

      // 🔹 Esperar a que se rendericen los estilos y sombras
      await new Promise(requestAnimationFrame);
      await new Promise(requestAnimationFrame);
      await new Promise((res) => setTimeout(res, 600));

      // 🔹 2️⃣ Capturar imagen del odontograma
      let imagenOdontograma = null;
      if (odontogramaRef.current && typeof odontogramaRef.current.capture === "function") {
        imagenOdontograma = await odontogramaRef.current.capture();
      } else {
        console.warn("⚠️ No se encontró ref.capture, usando fallback html2canvas directo");
        const canvas = await html2canvas(odontogramaDiv, {
          backgroundColor: "#fff",
          scale: 2,
          useCORS: true,
          windowWidth: 1200,
          windowHeight: 800
        });
        imagenOdontograma = canvas.toDataURL("image/png");
      }

      // 🔹 3️⃣ Volver a ocultar el odontograma
      odontogramaDiv.style.visibility = "hidden";
      odontogramaDiv.style.position = "absolute";
      odontogramaDiv.style.top = "-9999px";

      // 2️⃣ Construye los datos normales del presupuesto
      const items = presupuesto.map(act => {
        const cantidad = Number(act.cantidad || 1);
        const importe = Number(act.importe || 0);
        const total = cantidad * importe;

        return {
          fecha: new Date().toLocaleDateString('es-ES'),
          clave: act.clave,
          tratamiento: act.denominacion,
          pieza: act.pieza,
          cuadrante: act.cuadrante,
          cantidad,
          precioUnitario: importe,
          total
        };
      });

      const datosPresupuesto = {
        n_expediente: expediente,
        clinica: "VILLA",
        items,
        idsActuaciones: actuaciones.map(a => a.id),
        total: totalGlobal,
        observaciones,
        imagen_odontograma: imagenOdontograma  // 👈 aquí se añade
      };
      console.log(datosPresupuesto);
      // 3️⃣ Enviar al backend
      const res = await axios.post('/api/presupuesto/pdf', datosPresupuesto, {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });

      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch (err) {
      console.error("Error al generar PDF:", err);
    }
  };

  return (
    <>

      <div className="presupuesto-page">
        <Breadcrumb />
        <h2>Presupuesto</h2>
        <div className="acciones-superiores">
          <button
              className="btn-imprimir"
              onClick={() => generarPDF("VILLA")}
          >
              Imprimir
          </button>
          <button
            className="volver-btn"
            onClick={() => history.push(`/pacientes/${expediente}/historial-clinico`)}
          >
            Volver al historial
          </button>
        </div>
        <table className="presupuesto-table">
          <thead>
            <tr>
              <th>Clave</th>
              <th>Tratamiento</th>
              <th>Pieza</th>
              <th>Cuadrante</th>
              <th>Arcada</th>
              <th>Cantidad</th>
              <th>Importe</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {presupuesto.map((act, index) => {
              const cantidad = Number(act.cantidad || 1);
              const importe = Number(act.importe || 0);
              const total = calcularTotalFila(cantidad, importe);

              return (
                <tr key={index}>
                  <td>{act.clave}</td>
                  <td>{act.denominacion}</td>
                  <td>{act.pieza}</td>
                  <td>{act.cuadrante}</td>
                  <td>{act.arcada}</td>
                  <td>{cantidad}</td>
                  <td>{importe.toFixed(2)} €</td>
                  <td>{total.toFixed(2)} €</td>
                </tr>
              );
            })}
            <tr className="fila-total">
              <td colSpan="7" style={{ textAlign: 'right' }}><strong>Total</strong></td>
              <td><strong>{totalGlobal.toFixed(2)} €</strong></td>
            </tr>
          </tbody>
        </table>
        <div className="observaciones-section">
          <h3>Observaciones</h3>
          <textarea
            value={observaciones}
            onChange={(e) => setObservaciones(e.target.value)}
            placeholder="Escribe observaciones o notas adicionales..."
            rows={4}
            style={{ width: '100%', resize: 'vertical' }}
          />
        </div>
      </div>
    
      <div
        id="odontograma-captura"
        style={{
          position: "absolute",
          top: "-9999px",
          left: "0",
          width: "1200px",
          background: "#fff",
          opacity: 1,
          visibility: "hidden",
          pointerEvents: "none",
          zIndex: -1
        }}
      >
        <Odontograma
          ref={odontogramaRef}
          soloLectura={true}
          piezasPresupuesto={presupuesto}
          hideChrome={true}   // NO renderiza Topbar/Breadcrumb/Toast
        />
      </div>

    </>
  );
}
